import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { selectRoles } from "../../../features/roleSlice";
import { fetchSubmissions } from "../../SBCF/SpecSheet/api";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

const TEAM_ROLES = ["SBCF Admin", "SBCF Assigner", "SBCF Team", "Admin"];

// Spec-sheet counts. SBCF team members see the queue they work
// ("assigner" = whole queue, "team" = assigned to me); everyone else sees
// their own submissions.
const SbcfWidget = () => {
  const user = useSelector(selectUser);
  const role = useSelector(selectRoles);
  const userRoles = role?.roles || [];
  const isAssigner =
    userRoles.includes("SBCF Assigner") ||
    userRoles.includes("SBCF Admin") ||
    userRoles.includes("Admin");
  const isTeam = TEAM_ROLES.some((r) => userRoles.includes(r));
  const mode = isAssigner ? "assigner" : isTeam ? "team" : "sales";

  const [submissions, setSubmissions] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    fetchSubmissions(mode, user.id)
      .then((list) => setSubmissions(Array.isArray(list) ? list : []))
      .catch(() => setFailed(true));
  }, [mode, user?.id]);

  const count = (status) =>
    submissions.filter((s) => s.status === status).length;

  return (
    <WidgetFrame
      title={isTeam ? "SBCF Spec Sheets" : "My SBCF Spec Sheets"}
      to={isTeam ? "/sbcfadmin" : "/sbcf"}
    >
      {submissions ? (
        <div className="grid grid-cols-3 gap-2">
          <WidgetStat value={count("New")} label="New" />
          <WidgetStat
            value={count("Assigned") + count("In Progress")}
            label="In progress"
          />
          <WidgetStat value={count("Complete")} label="Complete" />
        </div>
      ) : (
        <WidgetEmpty>
          {failed ? "Couldn't load spec sheets." : "Loading spec sheets…"}
        </WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default SbcfWidget;
